export default status => {
  if (status === 'INFO') {
    return 'info-circle';
  } if (status === 'WARNING') {
    return 'exclamation-circle';
  } if (status === 'NOT_SUPPORTED') {
    return 'exclamation-circle';
  } return 'check-circle';
};
